import api from "./api";
import endpoints from "./endpoints";

export default {
  getAttributeDataTypes: async function () {
    const result = await api.get(endpoints.attributeManager.attributeDataTypes.get, {});
    return result.data;
  }
};
